module.exports = __webpack_public_path__ + "img/pc_02.652b5e61.png";